import { trackCustomLinkUsage } from './analyticEvents';

/**
 * @method trackAdminPageVisit
 * @description This method tracks the admin page visit
 */
export const trackAdminPageVisit = (adminPageVisitName: string) => {
  trackCustomLinkUsage(adminPageVisitName, 'internal');
};
